import request from '../../../Helpers/Request';

class Combine {
    constructor(settings) {
        this.settings = settings;
    }

    values(id) {
        return new Promise((resolve, reject) => {
            request('GET', `/profiles/admin/${id}/combine`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    combined(id) {
        return new Promise((resolve, reject) => {
            request('GET', `/profiles/admin/${id}/combine/show`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    update(id, data) {
        return new Promise((resolve, reject) => {
            request('PUT', `/profiles/admin/${id}/combine`, this.settings, data)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }
}

export default Combine;
